import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=7006064c&"
import script from "./DownloadButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports